import { unauthorizedBackendApi } from '@app/services'

import { CheckRefreshTokenResponse } from './types'

export const checkRefreshToken = async () => {
  try {
    const { data } =
      await unauthorizedBackendApi.get<CheckRefreshTokenResponse>(
        '/users/checkRefreshToken'
      )
    return data?.doRefreshToken
  } catch (error) {
    console.error('Error checking refresh token:', error)

    throw error
  }
}
